<template>
  <v-container fluid>
    <a-form-model layout="vertical" :hideRequiredMark="true">
      <a-row :gutter="4">
        <a-col :span="24" :xxl="3" :xl="4" :lg="4" :md="8">
          <a-textarea v-model="queryForm.nos" placeholder="派车单号" :auto-size="{ minRows: 6, maxRows: 6 }" />
        </a-col>
        <a-col :span="24" :xxl="21" :xl="20" :lg="20" :md="16">
          <a-row :gutter="4">
            <a-col :span="24" :xxl="2" :xl="3" :lg="3" :md="6">
              <a-form-model-item label="查询方式">
                <a-select v-model="queryForm.day_type" placeholder="查询方式" :not-found-content="null">
                  <a-select-option key="block_t"> 封车日期 </a-select-option>
                  <a-select-option key="serial_t"> 流水号日期 </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :xxl="4" :xl="6" :lg="6" :md="12">
              <a-form-model-item label="时间">
                <a-range-picker v-model="queryForm.times" :locale="locale" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
                  :allow-clear="false" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :xxl="3" :xl="4" :lg="4" :md="6">
              <a-form-model-item label="邮路">
                <a-input v-model="queryForm.postroute" placeholder="邮路" allow-clear>
                </a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :xxl="2" :xl="3" :lg="3" :md="6">
              <a-form-model-item label="邮路级别">
                <a-select v-model="queryForm.postroutelevel" placeholder="一干/二干" :not-found-content="null" allow-clear>
                  <a-select-option key="一级"> 一干 </a-select-option>
                  <a-select-option key="二级"> 二干 </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :xxl="2" :xl="3" :lg="3" :md="6">
              <a-form-model-item label="性质">
                <a-select v-model="queryForm.transport_kind" placeholder="单程/往返" :not-found-content="null" allow-clear>
                  <a-select-option key="单程"> 单程 </a-select-option>
                  <a-select-option key="往返"> 往返 </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :xxl="2" :xl="3" :lg="4" :md="6">
              <a-form-model-item label="车牌号/挂厢号">
                <a-input v-model="queryForm.vehicle_number" placeholder="车牌/挂厢" allow-clear>
                </a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :xxl="3" :xl="4" :lg="4" :md="6">
              <a-form-model-item label="派押局">
                <a-input v-model="queryForm.dispatch_post_office" placeholder="派押局" allow-clear>
                </a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :xxl="4" :xl="4" :lg="5" :md="6">
              <a-form-model-item label="派车响应单位">
                <a-input v-model="queryForm.dispatch_response_corp" placeholder="派车响应单位" allow-clear>
                </a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :xxl="2" :xl="3" :lg="3" :md="6">
              <a-form-model-item label="车型">
                <a-select v-model="queryForm.vehicle_type" placeholder="请选择" :not-found-content="null" allow-clear>
                  <a-select-option v-for="item in vehicle_types" :key="item.value"> {{ item.label }} </a-select-option>
                  <a-select-option key="未匹配"> 未匹配 </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :xxl="3" :xl="4" :lg="4" :md="6">
              <a-form-model-item label="所属公司">
                <a-select v-model="queryForm.corp" :options="corps" placeholder="请选择" :not-found-content="null"
                  allow-clear>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :xxl="2" :xl="3" :lg="3" :md="6">
              <a-form-model-item label="车辆归属">
                <a-select v-model="queryForm.own_type" :options="own_types" placeholder="请选择" :not-found-content="null"
                  allow-clear>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :xxl="3" :xl="4" :lg="4" :md="6">
              <a-form-model-item label="状态">
                <a-select v-model="queryForm.state" :options="states" placeholder="请选择" :not-found-content="null"
                  allow-clear>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :xxl="4" :xl="6" :lg="3" :md="12">
              <div class="d-flex align-end" style="margin-top:15px;height:42px;">
                <a-space>
                  <v-btn tile small class="primary white--text" @click="getdata()">
                    <v-icon small>mdi-magnify</v-icon>查询
                  </v-btn>
                  <v-btn tile small class="purple white--text" @click="getdata('download')">
                    <v-icon small>mdi-arrow-down-circle-outline</v-icon> 下载异常数据
                  </v-btn>
                </a-space>
              </div>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-form-model>
    <v-card tile class="mt-2">
      <v-data-table dense :headers="headers" :items="list" :items-per-page="list.length" no-data-text="无数据"
        hide-default-footer disable-sort fixed-header :height="height">
        <template v-slot:header.vehicle="{ }">
          <p>车牌号</p>
          <p>挂厢号</p>
        </template>
        <template v-slot:item.vehicle="{ item }">
          <p>{{ item.vehicle_number }}</p>
          <p>{{ item.vehicle_gnumber }}</p>
          <p class="error--text">{{ item.own_type_name }}</p>
        </template>
        <template v-slot:header.driver="{ }">
          <p>司机姓名</p>
          <p>司机电话</p>
        </template>
        <template v-slot:item.driver="{ item }">
          <p>{{ item.driver_name }}</p>
          <p>{{ item.driver_mobile }}</p>
        </template>
        <template v-slot:header.jh_dc="{ }">
          <p>计划发车时间</p>
          <p>车辆到场时间</p>
        </template>
        <template v-slot:item.jh_dc="{ item }">
          <p>{{ item.jh_time }}</p>
          <p>{{ item.dc_time }}</p>
        </template>
        <template v-slot:header.block_out_in="{ }">
          <p>封车时间</p>
          <p>出围栏时间</p>
          <p>入围栏时间</p>
        </template>
        <template v-slot:item.block_out_in="{ item }">
          <p>{{ item.block_time }}</p>
          <p>{{ item.out_time || '--' }}</p>
          <p>{{ item.in_time || '--' }}</p>
        </template>
        <template v-slot:item.state="{ item }">
          <a-tag v-if="item.isearly === false" color="orange">
            未按时到位
          </a-tag>
          <a-tag v-if="item.istimly === false" color="pink">
            未按时发车
          </a-tag>
          <a-tag v-if="item.isinout === false" color="purple">
            无进出围栏
          </a-tag>
          <a-tag v-if="item.islatly === false" color="red">
            晚点
          </a-tag>
        </template>
        <template v-slot:item.check_amount1="{ item }">
          <p class="error--text">{{ item.check_amount1 }}</p>
          <p>{{ item.check_reason1 }}</p>
        </template>
        <template v-slot:item.check_amount2="{ item }">
          <p class="error--text">{{ item.check_amount2 }}</p>
          <p>{{ item.check_reason2 }}</p>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn color="error" tile small @click="showcheck(item)">考核</v-btn>
        </template>
      </v-data-table>
      <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
    </v-card>
    <v-dialog v-model="checkmodel" persistent max-width="400px">
      <v-form ref="checkform">
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            考核
            <v-icon @click="() => checkmodel = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-col cols="6">
                  邮局：{{ checkform.postoffice }}
                </v-col>
                <v-col cols="6">
                  邮路：{{ checkform.postroute }}
                </v-col>
                <v-col cols="6">
                  派车单号：{{ checkform.dispatch_no }}
                </v-col>
                <v-col cols="6">
                  车牌号：{{ checkform.vehicle_number }}
                </v-col>
                <v-col cols="12">
                  司机：{{ checkform.driver_name }}/{{ checkform.driver_mobile }}
                </v-col>
                <v-col cols="12">
                  状态：
                  <a-tag v-if="checkform.isearly === false" color="orange">
                    未按时到位
                  </a-tag>
                  <a-tag v-if="checkform.istimly === false" color="pink">
                    未按时发车
                  </a-tag>
                  <a-tag v-if="checkform.isinout === false" color="purple">
                    无进出围栏
                  </a-tag>
                  <a-tag v-if="checkform.islatly === false" color="red">
                    晚点
                  </a-tag>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="checkform.check_amount1" label="邮局考核" type="number" outlined dense
                    hide-details>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea v-model="checkform.check_reason1" label="考核原因" rows="2" outlined dense
                    hide-details></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="checkform.check_amount2" label="司机考核" type="number" outlined dense
                    hide-details>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea v-model="checkform.check_reason2" label="考核原因" rows="2" outlined dense
                    hide-details></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <span class="error--text">考核金额填写负数</span>
            <v-spacer></v-spacer>
            <v-btn tile color="primary" @click="confirmcheck">保存</v-btn>
            <v-btn tile @click="() => checkmodel = false">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "underscore";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { mapState } from "vuex";
export default {
  name: "OrderEList",
  data() {
    return {
      locale,
      corps: [],
      own_types: [],
      vehicle_types: [],
      states: [
        { value: 1, label: '未按时到位' },
        { value: 2, label: '未按时发车' },
        { value: 3, label: '无进出围栏' },
        { value: 4, label: '晚点' },
      ],
      queryForm: {
        nos: "",
        day_type: 'block_t',
        times: [null, null],
        postroute: undefined,
        postroutelevel: undefined,
        transport_kind: undefined,
        vehicle_number: null,
        dispatch_post_office: null,
        dispatch_response_corp: null,
        vehicle_type: undefined,
        corp: undefined,
        own_type: undefined,
        state: undefined,
      },
      headers: [
        { text: "邮局", value: "postoffice", width: 120, align: "center" },
        { text: "派车单号", value: "dispatch_no", width: 100, align: "center" },
        { text: "邮路", value: "postroute", width: 160, align: "center" },
        { value: "vehicle", width: 120, align: "center" },
        { value: "driver", width: 120, align: "center" },
        { value: "jh_dc", width: 160, align: "center" },
        { value: "block_out_in", width: 160, align: "center" },
        { text: "状态", value: "state", width: 100, align: "center" },
        { text: "邮局考核", value: "check_amount1", width: 100, align: "center" },
        { text: "司机考核", value: "check_amount2", width: 100, align: "center" },
        { text: "操作", value: "action", width: 150, align: "center" }
      ],
      page: 1,
      limit: 20,
      list: [],
      length: 0,
      count: 0,
      height: 600,
      vrules: {
        required: (value) => !!value || "不能为空"
      },
      checkmodel: false,
      checkform: {},
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
  },
  components: {},
  watch: {
    '$route.query.nos'(nos) {
      if (nos) {
        this.queryForm.nos = (nos || "").split(',').join('\n');
        this.getdata();
      }
    },
    page() {
      this.getdata();
    },
    limit() {
      if (this.page !== 1) this.page = 1;
      else this.getdata();
    },
  },
  mounted() {
    this.height = window.innerHeight - 300;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 300;
    };
    this.page = 1;
    this.list = [];
    this.length = 0;
    this.count = 0;
    this.queryForm = {
      nos: (this.$route.query.nos || "").split(',').join('\n'),
      day_type: 'block_t',
      times: [
        this.$moment().subtract(3, 'day').format('YYYY-MM-DD'),
        this.$dateFormat(),
      ],
      postroute: undefined,
      postroutelevel: undefined,
      transport_kind: undefined,
      vehicle_number: null,
      dispatch_post_office: null,
      dispatch_response_corp: null,
      vehicle_type: undefined,
      corp: undefined,
      own_type: undefined,
      state: undefined,
    }
    this.getdata();
  },
  methods: {
    getdata(action) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/waybill/elist", {
        page: this.page,
        limit: this.limit,
        ...this.queryForm,
        action,
      }).then((res) => {
        this.$toast.clear();
        // console.log(res);
        if (res.code === 0) {
          if (action === 'download') {
            return this.$download(res.data.url, res.data.name);
          }
          this.list = res.data.list.map(n => {
            return {
              ...n,
              create_time: this.$dateFormat(n.create_time, 'YYYY-MM-DD HH:mm:ss'),
              update_time: n.update_time ? this.$dateFormat(n.update_time, 'YYYY-MM-DD HH:mm:ss') : "",
            }
          });
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
          this.corps = res.data.corps;
          this.own_types = res.data.own_types;
          this.vehicle_types = res.data.vehicle_types;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showcheck(item) {
      this.checkform = {
        _id: item.waybillid,
        isearly: item.isearly,
        istimly: item.istimly,
        isinout: item.isinout,
        islatly: item.islatly,
        postoffice: item.postoffice,
        dispatch_no: item.dispatch_no,
        postroute: item.postroute,
        vehicle_number: item.vehicle_number,
        vehicle_gnumber: item.vehicle_gnumber,
        driver_name: item.driver_name,
        driver_mobile: item.driver_mobile,
        check_amount1: item.check_amount1 || "",
        check_reason1: item.check_reason1 || "",
        check_amount2: item.check_amount2 || "",
        check_reason2: item.check_reason2 || "",
      };
      this.checkmodel = true;
    },
    confirmcheck() {
      if (!this.$refs.checkform.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/waybill/confirmcheck", { dataForm: this.checkform }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.checkmodel = false;
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: unset;
}

/deep/ .row+.row {
  margin-top: 0;
}

/deep/ .col {
  padding: 4px;
}

p {
  margin: 0;
}
</style>
